import { render, staticRenderFns } from "./LoginsAndOrdersReport.vue?vue&type=template&id=6ba96e4f&scoped=true&"
import script from "./LoginsAndOrdersReport.vue?vue&type=script&lang=js&"
export * from "./LoginsAndOrdersReport.vue?vue&type=script&lang=js&"
import style0 from "./LoginsAndOrdersReport.vue?vue&type=style&index=0&id=6ba96e4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba96e4f",
  null
  
)

export default component.exports